import * as React from "react";
import {Toast} from "primereact/toast";
import {useSelector} from "react-redux";
import {ApplicationState} from "../../store";
import { SupportIdErrorDetail } from './SupportIdErrorDetail';

export const AlertComponent: React.FC = () => {
  const toastRef = React.useRef<Toast>(null);
	const alertMessages = useSelector(
    (appState: ApplicationState) => appState.alerts.messages
  );
  React.useEffect(() => {
    if (toastRef?.current != null) {
      if (alertMessages && alertMessages?.length > 0) {
        toastRef.current.show(alertMessages.map(message => message.supportId ? {
          ...message,
          detail: <SupportIdErrorDetail detail={message.detail} supportId={message.supportId} />,
        } : message));
      }
    }
  }, [alertMessages]);

  return (
      <Toast ref={toastRef} />
  );
};
